import { memo } from 'react';
import { Link, useLocation } from 'react-router';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import { NavigateRoutesEnum } from '@features/routing/routesEnum';
import { menuDefinition } from '@layouts/toolbar/menuDefinition';
import { useHasPermission } from '@hooks/has-permission/useHasPermission';



const Menu = () => {

	const location = useLocation();
	const hasPermission = useHasPermission();

	return (
		<Navbar variant='dark' className='toolbar-menu'>
			<Nav>
				{menuDefinition.map(x => x.items && x.items.length > 0
					?
						(<NavDropdown
							key={x.id}
							title={x.name}
							id='basic-nav-dropdown'
							className='menu-item'
							active={x.items.some(item => location.pathname === item.id)}>
								{x.items.map(y =>
									<NavDropdown.Item as={Link}
										key={y.id}
										disabled={y.requiredRoles ? !hasPermission(y.requiredRoles) : false}
										active={location.pathname === y.id}
										to={y.id}>
											{y.name}
									</NavDropdown.Item>
								)}
						</NavDropdown>)
					:
						(<Nav.Link
							key={x.id}
							disabled={x.requiredRoles ? !hasPermission(x.requiredRoles) : false}
							as={Link}
							className='menu-item'
							active={location.pathname === x.id}
							to={x.id}>
								{x.name}
						</Nav.Link>)
				)}

				<Nav.Link className={`menu-item search-item${location.pathname === NavigateRoutesEnum.search ? ' active-search' : ''}`} as={Link}
					active={location.pathname === NavigateRoutesEnum.search}
					to={NavigateRoutesEnum.search}>
					Vyhledávání
				</Nav.Link>
			</Nav>
		</Navbar>
	);
}

export default memo(Menu);